<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    :scrollable="false"
    sizeClass="modal-xl"
    icon="fa-shapes"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3" v-if="!loading">
      <FormRow label="Name">
        <FormInputText v-model="shapePriceTypeData.name" field="name" placeholder="Name" />
      </FormRow>
      <FormRow label="Straight Edge Limit" helpTip="Number of straight edges on the shape. Must be less than or equal to this value">
        <FormInputText v-model="shapePriceTypeData.straightEdgeCountLimit" field="straightEdgeCountLimit" placeholder="Straight Edge Count" />
      </FormRow>
      <FormRow label="Straight Line Cut Limit" helpTip="Number of straight line cuts required to generate this shape from the original square panel. Must be less than or equal to this value">
        <FormInputText v-model="shapePriceTypeData.straightLineCutCountLimit" field="straightLineCutCountLimit" placeholder="Straight Line Cut Count" />
      </FormRow>
      <FormRow label="Perfect Arc Line Limit" helpTip="Number of perfect convex arcs in the shape, where the radius matches a panel dimension. Must be less than or equal to this value">
        <FormInputText v-model="shapePriceTypeData.perfectArcCountLimit" field="perfectArcCountLimit" placeholder="Perfect Arc Count" />
      </FormRow>
      <FormRow label="Shape Service Stock" helpTip="Optional service stock item added to the panel if the panel has this shape price type">
        <FormInputStockCode :stockType="InventoryStockTypes.glassService" v-model="shapePriceTypeData.stockId" placeholder="Service Stock" :dropdownAutoWidth="true" />
      </FormRow>
            
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import FormInputStockCode from '@/modules/inventory/components/formInputStockCode'

import { InventoryStockTypes, OrderEditorCutoutTypes, OrderEditorCutoutTypeLookup, CutoutPolishFilterTypes, CutoutPolishFilterTypeLookup, OrderEditorGeometryShapeTypes, OrderEditorGeometryShapeTypeLookup } from '@/store/types'

export default {
  name: 'ShapePriceTypeDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    FormInputStockCode
  },
  props: {
    isCreateMode: Boolean,
    id: Number,
  },
  data() {
    return {
      dialogForm: {},
      shapePriceTypeData: {
        
      },
      submitting: false,
      loading: false,
      loadingError: '',
    }
  },
  created() {
    this.InventoryStockTypes = InventoryStockTypes
  },
  mounted() {
    if(!this.isCreateMode && this.id) {
      this.loading = true
      this.loadingError = ''

      this.requestData()
      .then(() => {
      })
      .catch(err => {
        this.loadingError = 'Error loading data. Check your internet connection and try again'
      })
      .finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Shape Price Type' : 'Edit Shape Price Type'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show() {
      // Reset form
      this.shapePriceTypeData = {
        
      }
      this.dialogForm = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.shapePriceTypeData)
      
      if(this.isCreateMode) {
        this.$apiService.orderEditorService.createOrderEditorShapePriceType(updateData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.orderEditorService.updateOrderEditorShapePriceType(updateData.id, updateData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    },
    requestData() {
      return new Promise((resolve, reject) => {

        this.$apiService.orderEditorService.getOrderEditorShapePriceType(this.id)
        .then(response => {
          this.shapePriceTypeData = response.data

          return resolve()
        })
        .catch(err => {
          return reject(err)
        })
      })
    }
  }
}
</script>